import React from 'react';
export const Separator = (props) => (React.createElement("div", { className: `separator ${props.type} ${props.fullSize ? 'full-size' : ''}` }));
